import { render, staticRenderFns } from "./predictItemLq.vue?vue&type=template&id=60f855ea&scoped=true&"
import script from "./predictItemLq.vue?vue&type=script&lang=js&"
export * from "./predictItemLq.vue?vue&type=script&lang=js&"
import style0 from "./predictItemLq.vue?vue&type=style&index=0&id=60f855ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f855ea",
  null
  
)

export default component.exports